import React from 'react';
import { Card, Input, Space, Button, message } from 'antd';

const { TextArea } = Input;

const StringHexConvert: React.FC = () => {
  const [stringValue, setStringValue] = React.useState('');
  const [hexValue, setHexValue] = React.useState('');

  // 字符串转十六进制 (浏览器兼容版本)
  const stringToHex = () => {
    if (!stringValue.trim()) {
      message.error('请输入字符串');
      return;
    }

    try {
      // 使用TextEncoder来处理UTF-8编码
      const encoder = new TextEncoder();
      const bytes = encoder.encode(stringValue);
      const hex = Array.from(bytes)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');
      setHexValue('0x' + hex);
      message.success('转换成功');
    } catch (error) {
      message.error('转换失败');
    }
  };

  // 十六进制转字符串 (浏览器兼容版本)
  const hexToString = () => {
    if (!hexValue.trim()) {
      message.error('请输入十六进制');
      return;
    }

    try {
      let hex = hexValue.trim();
      if (hex.startsWith('0x')) {
        hex = hex.slice(2);
      }
      
      if (!/^[0-9a-fA-F]*$/.test(hex)) {
        throw new Error('无效的十六进制格式');
      }

      // 确保hex字符串长度为偶数
      if (hex.length % 2 !== 0) {
        hex = '0' + hex;
      }

      // 将十六进制转换为字节数组
      const bytes = new Uint8Array(hex.length / 2);
      for (let i = 0; i < hex.length; i += 2) {
        bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
      }

      // 使用TextDecoder来解码UTF-8
      const decoder = new TextDecoder('utf-8');
      const str = decoder.decode(bytes);
      setStringValue(str);
      message.success('转换成功');
    } catch (error) {
      message.error('十六进制格式错误或无法解码为有效字符串');
    }
  };

  const copyString = () => {
    if (stringValue) {
      navigator.clipboard.writeText(stringValue);
      message.success('已复制字符串到剪贴板');
    }
  };

  const copyHex = () => {
    if (hexValue) {
      navigator.clipboard.writeText(hexValue);
      message.success('已复制十六进制到剪贴板');
    }
  };

  const clearAll = () => {
    setStringValue('');
    setHexValue('');
    message.info('已清空所有内容');
  };

  return (
    <Card title="字符串/十六进制转换" className="tool-container-responsive">
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>字符串</div>
          <TextArea
            placeholder="输入字符串"
            value={stringValue}
            onChange={e => setStringValue(e.target.value)}
            rows={4}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Space>
              <Button onClick={copyString} disabled={!stringValue}>
                复制字符串
              </Button>
              <Button type="primary" onClick={stringToHex}>
                转为十六进制
              </Button>
            </Space>
          </div>
        </div>

        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>十六进制</div>
          <TextArea
            placeholder="输入十六进制 (支持0x前缀)"
            value={hexValue}
            onChange={e => setHexValue(e.target.value)}
            rows={4}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Space>
              <Button onClick={copyHex} disabled={!hexValue}>
                复制十六进制
              </Button>
              <Button type="primary" onClick={hexToString}>
                转为字符串
              </Button>
              <Button onClick={clearAll}>
                清空
              </Button>
            </Space>
          </div>
        </div>

        <div style={{ 
          padding: 12, 
          background: '#f5f5f5', 
          borderRadius: 6, 
          fontSize: 12, 
          color: '#666' 
        }}>
          <div style={{ fontWeight: 500, marginBottom: 4 }}>说明：</div>
          <div>• 支持UTF-8编码的字符串与十六进制相互转换</div>
          <div>• 十六进制可以包含或不包含0x前缀</div>
          <div>• 支持中文、emoji等Unicode字符</div>
        </div>
      </Space>
    </Card>
  );
};

export default StringHexConvert; 